import React, { useContext, useMemo } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

// context
import { EditorContext } from '../../../../context/EditorContext';

import { useAuthSession } from '../../../../hooks/useAuthSession';

import { SectionType } from '../../../../models/editor.model';
// models
import {
    FormulaTypesData,
    TestFormulaContent,
} from '../../../../models/formula.model';

interface TestNotificationBoxProps {
    testMessageContent?: TestFormulaContent | null;
}
const TestNotificationBox: React.FC<
    React.PropsWithChildren<TestNotificationBoxProps>
> = ({ testMessageContent }) => {
    const {
        editorDetails: { formulaType },
    } = useContext(EditorContext);

    const { user: currentUser } = useAuthSession();
    const customerId = currentUser?.customerId;

    const showTestMessage = useMemo<boolean>(
        () =>
            !!formulaType &&
            !!FormulaTypesData[formulaType].isIntegrated?.(customerId),
        [customerId, formulaType],
    );

    const formulaHasMessageSection = useMemo<boolean>(() => {
        if (formulaType) {
            const data = FormulaTypesData[formulaType];
            return data
                .getTemplate()
                .some(
                    (item) => (item as any).sectionType === SectionType.message,
                );
        }
        return false;
    }, [formulaType]);

    if (!showTestMessage) return null;

    return (
        <TestNotification>
            <BoxDataContainer>
                <div>
                    {formulaHasMessageSection ? (
                        <BoxParagraph>
                            {testMessageContent?.message}
                        </BoxParagraph>
                    ) : (
                        <>
                            <h5>{testMessageContent?.header}</h5>
                            <BoxParagraph>
                                {testMessageContent?.body}
                            </BoxParagraph>
                        </>
                    )}
                </div>
            </BoxDataContainer>
        </TestNotification>
    );
};

const TestNotification = styled.div(() => ({
    width: 250,
    boxShadow:
        '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing(2),
    backgroundColor: aampeTheme.colors.gray25,
}));

const BoxParagraph = styled.p(() => ({
    color: aampeTheme.colors.neutral09,
    fontSize: '14px',
    paddingTop: aampeTheme.spacing(1),
}));
const BoxDataContainer = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
}));

export default TestNotificationBox;
